module.exports = __webpack_public_path__ + "img/cpjs2.851dd3d2.png";